import {
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST,
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS,
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE,
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_REQUEST,
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_SUCCESS,
  LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_FAILURE,
  GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST,
  GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS,
  GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE,
  CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST,
  CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS,
  CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE,
  UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST,
  UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS,
  UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE,
  DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST,
  DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS,
  DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE
} from '../../constants/sample-station-section'

const initialState = {
  sampleStationPlatformOperationSections: [],
  sampleStationPlatformOperationSection: {},
  sampleStationPlatformOperationSectionSummary: [],
  loading: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingCreate: false,
  loadingDelete: false,
  pageable: {
    page: 1,
    size: 10
  },
  error: ''
}

const sampleStationPlatformOperationSection = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST:
      return {
        ...state,
        sampleStationPlatformOperationSections: [],
        loading: true
      }
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS:
      return {
        ...state,
        loading: false,
        sampleStationPlatformOperationSections: action.payload,
        error: null,
        pageable: action.pageable
      }
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_REQUEST:
      return {
        ...state,
        loadingSummary: true
      }
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        error: null,
        sampleStationPlatformOperationSectionSummary: action.payload
      }
    case LIST_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUMMARY_FAILURE:
      return {
        ...state,
        loadingSummary: false,
        error: action.payload
      }
    case GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        error: null,
        sampleStationPlatformOperationSection: action.payload
      }
    case GET_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        error: null
      }
    case CREATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        error: null
      }
    case UPDATE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        error: null
      }
    case DELETE_SAMPLE_STATION_PLATFORM_OPERATION_SECTION_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default sampleStationPlatformOperationSection
